import { LabelHTMLAttributes, forwardRef } from 'react';

export interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  error?: boolean;
  required?: boolean;
}

export const Label = forwardRef<HTMLLabelElement, LabelProps>(
  ({ className = '', children, error, required, ...props }, ref) => {
    return (
      <label
        ref={ref}
        className={`block text-sm/6 font-medium text-secondary-900 mb-2 dark:text-white ${className}`}
        {...props}
      >
        {children}
        {required && <span className="text-danger-500 ml-1">*</span>}
        {error && <span className="text-danger-600 dark:text-danger-400 ml-1">*</span>}
      </label>
    );
  }
);

Label.displayName = 'Label';
